"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
/**
 * The type of the content recorded in the documents for the service
 */
const ModelHelper_1 = require("./ModelHelper");
class Content {
    constructor(json) {
        Object.assign(this, json, json.binaryValue ? { binaryValue: ModelHelper_1.b64_2ab(json.binaryValue) } : {});
    }
}
exports.Content = Content;
//# sourceMappingURL=Content.js.map